"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TREZOR_DESCS = void 0;
exports.TREZOR_DESCS = [
    { vendorId: 0x534c, productId: 0x0001 },
    { vendorId: 0x1209, productId: 0x53c0 },
    { vendorId: 0x1209, productId: 0x53c1 },
];
//# sourceMappingURL=constants.js.map